import * as React from "react";
// import Button from "@material-ui/core/Button";
import printJS from "print-js";
import { connect } from "react-redux";
import { IRootState } from "../../reducers";
import styled from "styled-components";
import "../../Printform.css";
import { history } from "../../store/config";
/* import {
    getPrintDate,
    handleCaseType, handleClaimStatus, handleClaimType,
    handleComplaintStatus,
    handleGrantTypes, handleIncaseofshipment, handleIssueType,
    handleYesNo, handleYesNoShipment
} from "../detail/form_utility"; */
import MainformPreviewComponent from "./mainform";
import ShipmentformPreviewComponent from "./shipmentform";
import ShipmentinventoryformPreviewComponent from "./shipmentinventoryform";
import QmuformPreviewComponent from "./qmuform";
import InventoryformPreviewComponent from "./inventoryform";
import MainFormIncidentReportPreviewComponent from "./mainform-incident-report"
import WhNonconformityMainformPreviewComponent from "./wh-nonconformity-mainform";
import { withStyles } from "@material-ui/core";
import { toolbarStyles, CustomButton } from "src/styles/general";
import { CaseFormType } from "src/constants/api";

export const PRIMARY_COLOR: string = "#1CABE2";

export const SectionWrapper = styled.div``;
export const PrintSectionHeader: any = styled.div``;
export const PrintItemWrapper: any = styled.div``;
export const PrintItemLabel = styled.div``;
export const PrintItemValue: any = styled.div``;
export const PrintItemContainer: any = styled.div``;
export const ComponentWrapper = styled.div``;

class PrintPreviewComponent extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  componentDidMount(): void {
    //console.log("props-->", this.props);
  }

  componentWillReceiveProps(nextProps: Readonly<any>, nextContext: any): void {
    //console.log("props-->", this.props);
  }

  public render() {
    const { values } = this.props.mainForm.mainForm;
    const { classes } = this.props;
    return (
      <div className="containerPrint">
        <CustomButton
          className={classes.staticToolbarButton}
          variant="contained"
          color="primary"
          onClick={() =>
            printJS({
              printable: "print-section",
              type: "html",
              css: ["print.css"],
            })
          }
        >
          Print
        </CustomButton>

        <CustomButton
          className={classes.staticToolbarButton}
          variant="contained"
          color="primary"
          onClick={this.goBack}
        >
          Back
        </CustomButton>

        <div className="print-div" id="print-section">
          {values.caseFormType === CaseFormType.Standard && <MainformPreviewComponent />}
          {values.caseFormType === CaseFormType.Incident && <MainFormIncidentReportPreviewComponent />}
          {values.caseFormType === CaseFormType.WarehouseNonConformity && <WhNonconformityMainformPreviewComponent />}
          {values.issueType === 6 &&
            values.shipments &&
            values.shipments.length > 0 ? (
            <InventoryformPreviewComponent />
          ) : null}
          {values.issueType === 1 &&
            values.shipments &&
            values.shipments.length > 0 ? (
            <ShipmentformPreviewComponent />
          ) : null}
          {values.shipments && values.shipments.length > 0 ? (
            <ShipmentinventoryformPreviewComponent />
          ) : null}
          {values.qmus && values.qmus.length > 0 ? (
            <QmuformPreviewComponent />
          ) : null}
        </div>
      </div>
    );
  }

  private goBack() {
    history.goBack();
  }

  /* private print = () =>{
        window.print();
    } */
}

const mapStateToProps = (state: IRootState) => {
  return {
    mainForm: state.form,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(toolbarStyles)(PrintPreviewComponent));
